import { InsertDriveFile as InsertDriveFileIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';

import InvoiceStat from './InvoiceStat';

interface OutstandingInvoicesProps {
    invoices?: [];
    usersCurrency: string;
}

const OutstandingInvoices = ({ invoices, usersCurrency }: OutstandingInvoicesProps) => {
    const totalInvoices = invoices?.length;

    const totalInvoicesAmount = invoices?.reduce((acc, curr) => {
        return acc + curr.totalInvoiceAmount;
    }, 0);

    return (
        <Grid
            sx={{
                padding: '0 24px 24px 8px',
                display: 'flex',
                flexDirection: 'column',
            }}
            gap={2}
        >
            <Grid item container gap={2} sx={{ paddingLeft: '12px' }}>
                <InvoiceStat
                    label="Total Invoices"
                    icon={<InsertDriveFileIcon sx={{ color: '#FDC800' }} />}
                    value={totalInvoices}
                />
                <InvoiceStat
                    label="Total Invoices Amount"
                    value={totalInvoicesAmount}
                    usersCurrency={usersCurrency}
                />
            </Grid>
        </Grid>
    );
};

export default OutstandingInvoices;
